var Handlebars = require("../node_modules/_handlebars@4.5.3@handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"eruda-dom-tree\"></ul>\n<div class=\"eruda-inspect\">Inspect Selected Element</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/template.hbs
// module id = 120
// module chunks = 0